import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/components/ui/tabs";
import { AssistantSchedule } from "./AssistantSchedule";
import { EngineQueuePanel } from "./EngineQueuePanel";
import { useTranslation } from "react-i18next";

// O histórico de reuniões migrou para o painel de Logs do Superadmin
// (aba Assistant → modo "Histórico") — aqui ficam as filas: Assistant
// (agenda de reuniões, PBI 81485) e Engine (jobs de workflow, AB#84619).
//
// A configuração vive dentro da aba Assistant, junto do endereço da caixa que ela
// configura: aqui em cima ela ficava sobre as duas abas, sugerindo valer também
// para a Engine, que não tem nada a ver com ela.
export const AssistantSettings = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("assistant");

  return (
    <div className="w-full">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="flex items-center justify-between border-b">
          <TabsList>
            <TabsTrigger value="assistant">{t("settings.tabs.assistant")}</TabsTrigger>
            <TabsTrigger value="engine">{t("settings.tabs.engine", "Engine")}</TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="assistant" className="mt-0 w-full">
          <AssistantSchedule />
        </TabsContent>

        <TabsContent value="engine" className="mt-0 w-full">
          <EngineQueuePanel />
        </TabsContent>
      </Tabs>
    </div>
  );
};
